import template from "./customer-register-confirm-page-html.twig";

Packlab.Component.register('customer-register-confirm-page', {
    template,

});
